import { secureLubaApi } from '../secureLubaApi';

export const userApi = secureLubaApi.injectEndpoints({
  endpoints: (build) => ({
    // Backend GET /user/me returns the resolved context user, including the DB-backed
    // isOrgViewWhitelisted flag (not present in the Entra token claims).
    getMe: build.query({
      query: () => `/user/me`,
      providesTags: [{ type: 'Me', id: 'CURRENT' }],
    }),
  }),
});

export const { useGetMeQuery } = userApi;
